<template>
  <el-dialog
    :title="isUpdate ? '编辑商户' : '添加商户'"
    :visible="visible"
    width="800px"
    :destroy-on-close="true"
    :lock-scroll="false"
    custom-class="ele-dialog-form"
    @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="82px">
      <el-row :gutter="15">
        <el-col :sm="12">
          <el-form-item label="登录账号:" prop="username">
            <el-input
              clearable
              :maxlength="20"
              v-model.trim="form.username"
              placeholder="请输入"
              :disabled="isUpdate" />
          </el-form-item>
          <el-form-item label="手机号码:" prop="mobile">
            <el-input
              clearable
              :maxlength="11"
              v-model.trim="form.mobile"
              placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item label="用户昵称:" prop="realname">
            <el-input
              clearable
              :maxlength="20"
              v-model.trim="form.realname"
              placeholder="请输入" />
          </el-form-item>
          <el-form-item label="电子邮箱:" prop="email">
            <el-input
              clearable
              :maxlength="50"
              v-model.trim="form.email"
              placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" @click="save" :loading="loading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import validate from 'ele-admin/packages/validate';

const emptyForm = () => ({
  username: '',
  realname: '',
  mobile: '',
  email: '',
  status: 1
});

export default {
  name: 'UserEdit',
  props: {
    visible: Boolean,
    data: Object
  },
  data() {
    return {
      form: emptyForm(),
      rules: {
        username: [{ required: true, message: '请输入', trigger: 'blur' }],
        email: [{ pattern: validate.email, message: '邮箱格式不正确', trigger: 'blur' }],
        mobile: [{ pattern: validate.phone, message: '手机号格式不正确', trigger: 'blur' }]
      },
      loading: false,
      isUpdate: false
    };
  },
  watch: {
    data: {
      immediate: true,
      handler(val) {
        if (val && val.id) {
          this.form = Object.assign(emptyForm(), {
            id: val.id,
            username: val.username,
            realname: val.realname,
            mobile: val.mobile,
            email: val.email,
            status: val.status || 1
          });
          this.isUpdate = true;
        } else {
          this.form = emptyForm();
          this.isUpdate = false;
        }
      }
    }
  },
  methods: {
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        this.$http
          .post('/user/edit', this.form)
          .then((res) => {
            this.loading = false;
            if (res.data.code === 0) {
              this.$message.success(res.data.msg);
              this.updateVisible(false);
              this.$emit('done');
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error(e.message);
          });
      });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    }
  }
};
</script>
